import clsx from 'clsx';
import { endOfDay } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { useParams } from 'react-router-dom';
import { toTitleCase } from '../../../../../../_metronic/helpers';
import { TldFrequency, TldReportStatus } from '../../../../../pages/tld/mappings';
import { useFilter } from '../../FilterContext';
import MultiSelection from '../../components/MultiSelection';
import SearchInputGroup from '../../components/SearchInputGroup';
import SingleSelection from '../../components/SingleSelection';
import DatePickerFilter from '../components/DatePickerFilter';

export function ReportsFilter() {
  const params = useParams();
  const { globalFilter, setGlobalFilter } = useFilter();

  const statusOptions = Object.values(TldReportStatus).map((status) => ({
    value: status,
    label: toTitleCase(status),
  }));

  const frequencyOptions = Object.values(TldFrequency).map((frequency) => ({
    value: frequency,
    label: toTitleCase(frequency),
  }));

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        <div className='hstack justify-content-between align-items-end'>
          {/* Select */}
          <div className='d-flex flex-wrap'>
            {/* Reported At */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  tldReports: {
                    ...globalFilter.tldReports,
                    active_notified_at: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              label='Reported At'
              placeholder='Filter Reported At...'
              className='me-6'
            />

            {/* Status */}
            {/* <MultiSelection
              title='Status'
              globalFilterValue={globalFilter?.tldReports?.status?.values}
              options={statusOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  tldReports: {
                    ...globalFilter.tldReports,
                    status: { type: 'in', values: e },
                  },
                });
              }}
            /> */}

            {/* Frequency */}
            <MultiSelection
              title='Frequency'
              globalFilterValue={globalFilter?.tldReports?.['schedule.frequency']?.values}
              options={frequencyOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  tldReports: {
                    ...globalFilter.tldReports,
                    ['schedule.frequency']: { type: 'in', values: e },
                  },
                });
              }}
            />

            {/* Start At */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  tldReports: {
                    ...globalFilter.tldReports,
                    ['report_period.start_at']: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              label='Start At'
              placeholder='Filter Start At...'
              className='me-6'
            />

            {/* End At */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  tldReports: {
                    ...globalFilter.tldReports,
                    ['report_period.end_at']: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              label='End At'
              placeholder='Filter End At...'
              className='me-6'
            />

            {/* Alert */}
            <MultiSelection
              title='Alert'
              globalFilterValue={globalFilter?.tldReports?.has_alert?.values}
              options={[
                { value: true, label: 'Yes' },
                { value: false, label: 'No' },
              ]}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  tldReports: {
                    ...globalFilter.tldReports,
                    has_alert: { type: 'in', values: e },
                  },
                });
              }}
            />

            {/* Registered Type */}
            <MultiSelection
              title='Site Registered Type'
              globalFilterValue={globalFilter?.tldReports?.['details.registered']?.values}
              options={[
                { value: true, label: 'Registered' },
                { value: false, label: 'Unregistered' },
              ]}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  tldReports: {
                    ...globalFilter.tldReports,
                    'details.registered': { type: 'in', values: e },
                  },
                });
              }}
            />
          </div>
        </div>

        {/* Search */}
        <SearchInputGroup
          inputs={[
            // { key: 'report_id', title: 'Report ID', minWidth: 240 },
            { key: 'merchant_id', title: 'Client ID', minWidth: 240 },
            { key: 'group_name', title: 'Group Name', minWidth: 240 },
            { key: 'details.mid', title: 'Site MID', minWidth: 240 },
            { key: 'details.url', title: 'Site URL', minWidth: 240 },
            {
              key: 'details.transaction_count',
              title: 'Site Transaction Count',
              searchType: 'number',
              minWidth: 240,
            },
            {
              key: 'details.internal_remarks.translations.label',
              title: 'Site Austreme Remark',
              minWidth: 240,
            },
            { key: 'details.remark', title: 'Site Client Remark', minWidth: 240 },
          ]}
          section='tldReports'
          globalFilterValue={globalFilter}
          onSubmit={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              tldReports: { ...globalFilter.tldReports, ...searchValues },
            })
          }
          onClear={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              tldReports: { ...globalFilter.tldReports, ...searchValues },
            })
          }
        />
      </div>
    </>
  );
}
